import useSWR from 'swr'

import { useCallMutation } from '@/common/api/client'
import { apiPutFetcher } from '@/common/api/fetcher'
import {
  GetNotificationSettingsResponse,
  GetNotificationSettingsVars,
  NotificationSettingsApiPath,
  UpdateNotificationSettingsResponse,
  UpdateNotificationSettingsVars,
} from '@/common/api/params/notificationSettings'

export const useNotificationSettingsGetApi = (vars: GetNotificationSettingsVars) => {
  return useSWR<GetNotificationSettingsResponse, Response, [string, GetNotificationSettingsVars]>([
    NotificationSettingsApiPath.GET_NOTIFICATION_SETTINGS,
    vars,
  ])
}

export const useNotificationSettingsUpdateApi = (options?: {
  onSuccess?: (response: UpdateNotificationSettingsResponse) => void
  onError?: (error: Response) => void
}) => {
  return useCallMutation<UpdateNotificationSettingsResponse, UpdateNotificationSettingsVars>(
    NotificationSettingsApiPath.UPDATE_NOTIFICATION_SETTINGS,
    { ...options, errorNotShown: true },
    apiPutFetcher,
  )
}
